import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjectVySida';
import { objektVyGrupp } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyGrupp';
import { associeradObjektVy } from '../../../_Common/Components/BusinessCollectionComponents/associeradObjektVy';
import { IObjektVy } from '../../../../../Types/ObjektVy';
import { standardVy, valjTyp } from '../../../../../Utils/ObjektVyUtils';

const forstaSida: IObjektVy = ObjektVySida(
  'forstaSida',
  [
    [
      objektVyGrupp(
        'verifikation',
        [
          associeradObjektVy(
            'Bokfverifikationer',
            valjTyp('verifikationsdata'),
            undefined
          ),
        ],
        ''
      ),
      objektVyGrupp(
        'konteringar',
        [
          associeradObjektVy(
            'Bokfverifikationer',
            valjTyp('konteringar'),
            undefined
          ),
        ],
        'Konteringar'
      ),
    ],
  ],
  1,
  'Fakturahändelse'
);

const standard: IObjektVy = standardVy([forstaSida]);

export const Fakturahandelsevyer: IObjektVy[] = [standard];
